(function () {
  'use strict';

  function initProductModal() {
    if (customElements.get('product-modal')) return;

    const ModalDialogBase = customElements.get('modal-dialog') || window.ModalDialog;
    if (!ModalDialogBase) return;

    class ProductModal extends ModalDialogBase {
      constructor() {
        super();
        this.openedBy = null;
      }

      hide() {
        super.hide();
        if (this.openedBy && typeof this.openedBy.focus === 'function') {
          this.openedBy.focus();
        }
      }

      show(opener) {
        super.show(opener);
        this.openedBy = opener;
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector('[data-media-id]:not([hidden])');
        if (activeMedia) {
          activeMedia.dispatchEvent(new CustomEvent('mediaVisible'));
        }
      }
    }

    customElements.define('product-modal', ProductModal);
  }

  if (customElements.get('modal-dialog') || window.ModalDialog) {
    initProductModal();
    return;
  }

  const handleDOMReady = function () {
    initProductModal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleDOMReady, { once: true });
  } else {
    handleDOMReady();
  }
})();